import React, { useEffect, useRef } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const SearchInputField = (props: any) => {
	const { t } = useTranslation();
	const {
		label,
		name,
		className,
		children,
		errorMessage = undefined,
		type = "search",
		required = false,
		placeholder = undefined,
		asterisksClass = null,
		inputClassName,
		customErrorClassName = null,
		pattern,
		validate,
		...rest
	} = props;

	const inputRef = useRef<HTMLInputElement | null>(null);

	const form = useFormContext();
	const field = form.register(props.name, {
		required: {
			value: props.required,
			message: props.errorMessage || "COMMON.REQUIRED_FIELD",
		},
		disabled: props.disabled,
		pattern,
		validate,
	});

	useEffect(() => {
		function handleBlur(event: MouseEvent | TouchEvent) {
			if (
				inputRef.current &&
				!inputRef.current.contains(event.target as Node)
			) {
				inputRef.current.blur();
			}
		}

		document.addEventListener("scroll", handleBlur);
		return () => {
			document.removeEventListener("scroll", handleBlur);
		};
	}, []);

	return (
		<>
			<input
				type={type}
				{...field}
				{...rest}
				ref={inputRef}
				name={name}
				className={inputClassName}
				placeholder={t(placeholder)}
				onChange={(e) => {
					form.setValue(props.name, e.target.value, {
						shouldDirty: true,
						shouldValidate: true,
					});
					props.onChange?.(e);
				}}
			/>
		</>
	);
};
export default SearchInputField;
